
function init()
{
    let $trending = $('.wp-home');

    if ( !$trending.length ) {

        return;
    }
    $('.trending').removeClass('pt-5 mt-5');

    $('.bg-b-g').removeClass('bg-b-g').addClass('bg-b-w');
}

$(() => {
    init();
});